export default "__VITE_ASSET__CqwHqwzG__"